module.exports = __webpack_public_path__ + "img/066.f95f864f.png";